import type { Offer } from './Offer'
import type { OfferProperty } from './OfferProperty'
import type { PartPackage } from './PartPackage'

export interface OfferPackage extends Offer {
    title?: string
    householdPackageId?: number
    realtyPackageId?: number
    liabilityPackageId?: number
    parts: PartPackage[]
}

export const OfferPackageSettingsFormTabs = {
    addons: 0,
    packages: 1,
    discounts: 2
}

export type OfferPackageSettingsFormTabs = typeof OfferPackageSettingsFormTabs[keyof typeof OfferPackageSettingsFormTabs]
export interface OfferPackageSettingsFormProps {
    onSuccess?: () => void
    onClose: () => void
    offer: OfferPackage | OfferProperty,
    isOpen: boolean
    title: string
    isReadOnly: boolean
    activeTab?: OfferPackageSettingsFormTabs | null
}

export interface OfferPackageSettingsFormValues {
    riskId: number,
    packageItemId: number,
    included: boolean
}

export type AddonDescriptionProps = {
    label?: React.ReactNode
    description?: React.ReactNode
    value?: React.ReactNode
}